import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=0ec7b145"
import script from "./BannerComponent.vue?vue&type=script&lang=ts"
export * from "./BannerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports